export default __webpack_public_path__ + "static/ITA_logo-e7b06385a58b1ff02e0bd4a75e0702e2.png";